import { useMutation } from '@apollo/client';
import { CURRENT_ACCOUNT } from '@application/api';
import { graphql } from '@gql/gql';
import type {
  MtLandingBreederUpdateProfileMutation,
  MtLandingBreederUpdateProfileMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';
import { MT_BREEDER_ONBOARDING_GET_PROFILE } from '../../MtBreederOnboardingPageController/api/useGetProfile';

export const MT_LANDING_BREEDER_UPDATE_PROFILE = graphql(`
  mutation MtLandingBreederUpdateProfile($data: AccountUpdateInput!) {
    accountMeUpdate(data: $data) {
      id
      dogBreeder {
        id
        hasStartedOnboarding
      }
    }
  }
`);

export const useUpdateProfile = () => {
  const [updateProfile, { error, loading }] = useMutation<
    MtLandingBreederUpdateProfileMutation,
    MtLandingBreederUpdateProfileMutationVariables
  >(MT_LANDING_BREEDER_UPDATE_PROFILE, {
    awaitRefetchQueries: true,
    refetchQueries: [MT_BREEDER_ONBOARDING_GET_PROFILE, CURRENT_ACCOUNT],
  });

  const updateProfileStartForm = useCallback(async () => {
    return updateProfile({
      variables: {
        data: {
          dogBreeder: {
            update: {
              data: {
                hasStartedOnboarding: { set: true },
              },
            },
          },
        },
      },
    });
  }, [updateProfile]);

  return {
    updateProfileLoading: loading,
    updateProfileError: error,
    updateProfile,
    updateProfileStartForm,
  };
};
